/* KWD cart panel (2026-09-17). One renderer, one open/close, replaces the theme's
   #CartDrawer + openDrawer/closeDrawer in theme.js and KWDDrawer in kwd-drawer.js.
   Works off /cart.js and /cart/change.js only. */
(function(){
  'use strict';
  var FREE=15000, HIDDEN=['ENTHUSIAST','CONNOISSEUR','SOMMELIER'];
  var ov, box, open=false, cart=null, busy=false;
  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  function money(c){return '$'+(c/100).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});}
  function img(u){ if(!u) return ''; return u.replace(/(\.[a-z]{3,4})(\?|$)/i,'_180x180$1$2'); }
  function build(){
    if(box) return;
    ov=document.createElement('div'); ov.className='kwdc-ov';
    box=document.createElement('aside'); box.className='kwdc'; box.setAttribute('role','dialog'); box.setAttribute('aria-label','Your cart');
    document.body.appendChild(ov); document.body.appendChild(box);
    ov.addEventListener('click',close);
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&open) close(); });
    box.addEventListener('click',function(e){
      var b=e.target.closest('[data-act]'); if(!b) return;
      var act=b.getAttribute('data-act');
      if(act==='close') return close();
      if(act==='checkout'){ window.location.href='/cart'; return; } /* owner: Check out goes to the cart page, where shipping and options are chosen */
      var row=b.closest('.kwdc-it'); if(!row) return;
      var key=row.getAttribute('data-key'), q=parseInt(row.getAttribute('data-qty'),10)||0;
      if(act==='plus') change(key,q+1,row); else if(act==='minus') change(key,Math.max(0,q-1),row); else if(act==='rm') change(key,0,row);
    });
    window.addEventListener('resize',place);
  }
  function place(){
    if(!box) return;
    var chip=document.querySelector('.kwd-cart'); if(!chip) return;
    var r=chip.getBoundingClientRect();
    box.style.setProperty('--kwdc-top',Math.round(r.bottom+12)+'px');
    box.style.setProperty('--kwdc-right',Math.max(12,Math.round(window.innerWidth-r.right))+'px');
  }
  function shipHTML(total){
    var rem=FREE-total, cls, txt, p=Math.max(0,Math.min(100,total/FREE*100));
    if(total>=FREE){ cls='is-ok'; txt='Free shipping unlocked'; }
    else if(total>=FREE-2000){ cls='is-close'; txt='Only '+money(rem)+' more for free shipping'; }
    else { cls='is-far'; txt=money(rem)+' more for free shipping'; }
    return '<div class="kwdc-ship '+cls+'"><b>'+txt+'</b><i style="--p:'+p.toFixed(1)+'%"></i></div>';
  }
  function itemHTML(it){
    var unit=it.price, orig=it.original_price>it.price?it.original_price:0;
    return '<div class="kwdc-it" data-key="'+esc(it.key)+'" data-qty="'+it.quantity+'">'
      +'<a class="kwdc-img" href="'+esc(it.url)+'"><img src="'+esc(img(it.image))+'" alt="" loading="lazy"></a>'
      +'<div><a class="kwdc-t" href="'+esc(it.url)+'">'+esc(it.product_title)+'</a>'
      +(it.variant_title&&it.variant_title!=='Default Title'?'<div class="kwdc-u">'+esc(it.variant_title)+'</div>':'')
      +'<div class="kwdc-u">'+money(unit)+' each</div>'
      +'<div class="kwdc-row"><span class="kwdc-q"><button type="button" data-act="minus" aria-label="Less">&minus;</button><span>'+it.quantity+'</span><button type="button" data-act="plus" aria-label="More">+</button></span>'
      +'<button type="button" class="kwdc-rm" data-act="rm">Remove</button></div></div>'
      +'<div class="kwdc-p">'+(orig?'<s>'+money(orig*it.quantity)+'</s>':'')+money(it.final_line_price!=null?it.final_line_price:unit*it.quantity)+'</div></div>';
  }
  function render(c){
    if(c) cart=c; if(!box) build(); if(!cart) return;
    var items=(cart.items||[]).filter(function(it){ return HIDDEN.indexOf(it.title)===-1; });
    var n=0; items.forEach(function(it){ if(it.handle!=='personalized-gift-card') n+=it.quantity; });
    var h='<div class="kwdc-hd"><div><h3>Your cart</h3><div class="kwdc-n">'+(n?n+(n===1?' bottle':' bottles'):'Nothing in it yet')+'</div></div><button type="button" class="kwdc-x" data-act="close" aria-label="Close">Close</button></div>';
    if(!items.length){
      h+='<div class="kwdc-empty"><div class="ic"></div><h4>Your cart is empty</h4><p>Free shipping on orders $150+ in the lower 48.</p><a class="kwdc-go" href="/collections/all-wine-products">Browse the shelves</a></div>';
    } else {
      h+=shipHTML(cart.total_price)+'<div class="kwdc-list">'+items.map(itemHTML).join('')+'</div>'
       +'<div class="kwdc-ft"><div class="kwdc-sum"><span>Subtotal</span><b>'+money(cart.total_price)+'</b></div><p class="kwdc-note">Taxes and any shipping are worked out at checkout.</p>'
       +'<button type="button" class="kwdc-go" data-act="checkout">Check out</button>'
       +'<div class="kwdc-links"><a href="#" data-act="close">Keep shopping</a></div></div>';
    }
    box.innerHTML=h;
  }
  function load(){
    return fetch('/cart.js',{credentials:'same-origin',cache:'no-store',headers:{'Accept':'application/json'}}).then(function(r){return r.ok?r.json():null;});
  }
  function change(key,qty,row){
    if(busy) return; busy=true; if(row) row.classList.add('busy');
    fetch('/cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){return r.json();}).then(function(c){ busy=false; render(c); try{window.KWDCart&&window.KWDCart.sync('change');}catch(e){} })
      .catch(function(){ busy=false; if(row) row.classList.remove('busy'); });
  }
  var lastToggle=0;
  function toggle(){ var t=Date.now(); if(t-lastToggle<350) return; lastToggle=t; open?close():show(); }
  function show(){
    build(); place(); open=true;
    document.documentElement.classList.add('kwdc-open');
    render(cart||{items:[],total_price:0});
    setTimeout(function(){ if(open){ ov.classList.add('on'); box.classList.add('on'); } },20);
    load().then(function(c){ if(c) render(c); });
  }
  function close(){
    if(!box) return; open=false; ov.classList.remove('on'); box.classList.remove('on');
    document.documentElement.classList.remove('kwdc-open');
  }
  function install(){
    window.openDrawer=show; window.closeDrawer=close;
    window.KWDDrawer={render:function(c){ render(c); }};
    var chip=document.getElementById('mySid_new');
    if(chip && chip.getAttribute('href')==='#'){ chip.removeAttribute('onclick'); if(!chip.__kwdc){ chip.__kwdc=1;
      chip.addEventListener('click',function(e){ e.preventDefault(); e.stopImmediatePropagation(); toggle(); },true);
      /* the carousels open the cart with jQuery's .trigger('click'), which never reaches a native listener on an <a> */
      if(window.jQuery){ window.jQuery(chip).on('click',function(e){ e.preventDefault(); toggle(); }); } } }
  }
  /* keep the panel honest when the cart changes elsewhere (adds, header sync) */
  /* any add-to-cart anywhere on the site (the header script tags the /cart/add call as 'add') opens the panel */
  document.addEventListener('kwd:cart:updated',function(e){ var d=e.detail||{}; if(!d.cart) return; cart=d.cart;
    /* never pop the panel on the cart page itself (the gift-card add-on there is an /cart/add too) */
    var onCartPage=/^\/cart\/?$/.test(location.pathname)||document.body.classList.contains('template-cart');
    if(d.reason==='add'){ if(onCartPage){ if(open) render(d.cart); return; } if(!open){ show(); } else { render(d.cart); } return; }
    if(open && d.reason!=='change') render(d.cart); });
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',install); else install();
  window.addEventListener('load',install);
})();
